















import TableFilters from "../../core/Table/TableFilters.vue";
import TableSort from "../../core/Table/TableSort.vue";
import { TableColumn } from "../../models/UI/TableColumn";
import { ContactApi } from "../../api/ContactApi";
import { Option } from "../../models/Option";
import { Contact } from "../../models/Contact";

export default {
    name: "FactureFournisseurListFilters",
    components: { TableSort, TableFilters },
    props: {
        defaultFilters: URLSearchParams,
    },
    data() {
        return {
            filters: {},
            ContactApi: new ContactApi(),
            columns: [
                {
                    id: "invoice_number",
                    name: "Numéro de facture",
                    type: TableColumn.ColumnType.text,
                    sort_field: "invoice_number",
                },
                /*{
                    id: "invoice_issuer",
                    name: "Fournisseur",
                    type: TableColumn.ColumnType.text,
                    sort_field: "invoice_issuer",
                },*/
                {
                    id: "clientIds",
                    name: "Fournisseur",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                    sort_field: "clients.nom",
                },
                {
                    id: "invoiceDate",
                    name: "Date facture",
                    type: TableColumn.ColumnType.date_range,
                    sort_field: "invoice_date",
                },
                {
                    id: "dueDate",
                    name: "Date d'échéance",
                    type: TableColumn.ColumnType.date_range,
                    sort_field: "due_date",
                },
                {
                    id: "totalHt",
                    name: "Montant total HT",
                    sort_field: "total_ht",
                },
                {
                    id: "created_at",
                    name: "Date d'ajout",
                    sort_field: "created_at",
                    default_sort: true,
                    default_value: TableColumn.SortOrder.desc,
                },
            ],
        };
    },
    created() {
        let self = this;
        self.ContactApi.getAllAsOptions({
            types: Contact.EType.Fournisseur,
            useCache: true,
        }).then(function (response) {
            let col = _.find(self.columns, { id: "clientIds" });
            col.options = Option.toTags(response);
        });
    },
    methods: {
        updateFilters(filters): void {
            this.filters = filters;
            this.$emit("update-filters", this.getFilters());
            this.$emit("input", this.getFilters());
        },
        updateSort(sort): void {
            this.$emit("update-sort", sort);
        },
        getFilters() {
            // Filtre client vide
            if (
                this.filters.clientIds &&
                _.includes(this.filters.clientIds, "-1")
            ) {
                this.filters.emptyClient = true;
            }
            return _.merge({}, this.filters);
        },
    },
};
